import { decodeSystemInstruction } from './system.js';
import { decodeTokenInstruction } from './token.js';
import { decodeComputeBudgetInstruction } from './compute-budget.js';
const decoders = [
    decodeSystemInstruction,
    decodeTokenInstruction,
    decodeComputeBudgetInstruction,
];
export function decodeInstruction(ix) {
    for (const decoder of decoders) {
        const result = decoder(ix);
        if (result)
            return result;
    }
    return undefined;
}
export { decodeSystemInstruction, decodeTokenInstruction, decodeComputeBudgetInstruction };
//# sourceMappingURL=index.js.map